<template>
  <div>
    <with-ylands></with-ylands>
    <the-tools></the-tools>
    <the-play-page></the-play-page>
    <!-- <ylands-creators-club></ylands-creators-club> -->
    <look-for-more></look-for-more>
    <enhance-experience></enhance-experience>
  </div>
</template>

<script>
import WithYlands from '@/components/home/sections/WithYlands';
import TheTools from '@/components/home/sections/TheTools';
import ThePlayPage from '@/components/home/sections/ThePlayPage';
import YlandsCreatorsClub from '@/components/home/sections/YlandsCreatorsClub';
import LookForMore from '@/components/home/sections/LookForMore';
import EnhanceExperience from '@/components/home/sections/EnhanceExperience';

export default {
  name: 'Home',
  components: {
    WithYlands,
    TheTools,
    ThePlayPage,
    YlandsCreatorsClub,
    LookForMore,
    EnhanceExperience,
  },
};
</script>

<style scoped lang="scss"></style>
